export async function savePackModalResult(
  { savedCount, failedCount, skippedCount },
  {
    fetchItems,
    refreshStockInconsistencySummary,
    setFinancialRefreshNonce,
    setSnackbarVariant,
    setSnackbarMessage,
    setShowMessage,
  },
) {
  await fetchItems();
  if (savedCount > 0) {
    void refreshStockInconsistencySummary({ silent: true });
  }
  setFinancialRefreshNonce((value) => value + 1);
  setSnackbarVariant(failedCount > 0 || skippedCount > 0 ? 'warning' : 'success');
  setSnackbarMessage(
    failedCount > 0 && skippedCount > 0
      ? `Se guardaron ${savedCount} publicaciones. ${failedCount} no se pudieron guardar y ${skippedCount} quedaron pendientes de actualización de stock en el canal.`
      : failedCount > 0
      ? `Se guardaron ${savedCount} publicaciones. ${failedCount} no se pudieron guardar.`
      : skippedCount > 0
      ? `Packs actualizados en ${savedCount} publicaciones. ${skippedCount} quedaron pendientes de actualización de stock en el canal.`
      : 'Packs actualizados',
  );
  setShowMessage(true);
}
